const scrim = require('../../../../../components/scrim/scrim')
const snack = require('../../../../../components/snack/snack')

export async function start(detail, phpFile) {
    scrim.showLoading()

    const checkboxesData = getFormData(detail.checkboxes);

    const payload = {
        id: detail.id,
        permissions: checkboxesData
    };

    const controller = new AbortController();
    const timeout = setTimeout(() => { controller.abort(); }, 30000);

    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload),
        signal: controller.signal,
        credentials: 'same-origin'
    };

    return await fetch(`./${phpFile}`, options)
        .then(handleErrors)
        .then(result => {
            clearTimeout(timeout);
            return result.json();
        })
        .then(parsedResult => {
            scrim.hideLoading()
            return parsedResult;
        })
        .catch(err => {
            clearTimeout(timeout);
            console.error('Error en Request: ', err);
            snack.start({ act: "show", id: "updateError" })
            throw err;
        })
        .finally(
            snack.start({ act: "show", id: "updateOk" })
        );
}

function handleErrors(response) {
    if (!response.ok) { throw Error(response.statusText) }
    return response;
}

function getFormData(checkboxes) {
    const data = {};

    if (!checkboxes) return data;

    checkboxes.forEach(input => {
        const entityName = input.getAttribute('data-entity');

        if (entityName) {
            const isChecked = input.checked;
            data[entityName] = isChecked ? 'readWrite' : 'none';
        }
    });

    return data;
}